import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Layout from "./components/Layout";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import Azienda from "./pages/Azienda";
import Servizi from "./pages/Servizi";
import ServizioDetail from "./pages/ServizioDetail";
import Certificazioni from "./pages/Certificazioni";
import Portfolio from "./pages/Portfolio";
import Contatti from "./pages/Contatti";
import Admin from "./pages/Admin";

const withLayout = (Component) => (
  <Layout>
    <Component />
  </Layout>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={withLayout(Home)} />
          <Route path="/azienda" element={withLayout(Azienda)} />
          <Route path="/servizi" element={withLayout(Servizi)} />
          <Route path="/servizi/:slug" element={withLayout(ServizioDetail)} />
          <Route path="/certificazioni" element={withLayout(Certificazioni)} />
          <Route path="/portfolio" element={withLayout(Portfolio)} />
          <Route path="/contatti" element={withLayout(Contatti)} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={withLayout(Home)} />
        </Routes>
        <Toaster
          position="bottom-right"
          richColors
          toastOptions={{
            style: {
              borderRadius: "12px",
              fontFamily: "IBM Plex Sans, sans-serif",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
